import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { baseUrl, defaultDescription, defaultImage, getSeoMeta, siteName } from '../utils/seo.ts'

export default function SEO() {
  const location = useLocation()

  useEffect(() => {
    const meta = getSeoMeta(location.pathname)
    const fullTitle = meta.title.includes(siteName) ? meta.title : `${meta.title} | ${siteName}`
    const url = `${baseUrl}${location.pathname}`
    const description = meta.description || defaultDescription

    document.title = fullTitle

    setMeta('name', 'description', description)
    setMeta('property', 'og:title', fullTitle)
    setMeta('property', 'og:description', description)
    setMeta('property', 'og:url', url)
    setMeta('property', 'og:type', meta.ogType || 'website')
    setMeta('property', 'og:site_name', siteName)
    setMeta('property', 'og:image', defaultImage)
    setMeta('property', 'twitter:card', 'summary_large_image')
    setMeta('property', 'twitter:title', fullTitle)
    setMeta('property', 'twitter:description', description)
    setMeta('property', 'twitter:image', defaultImage)
    setCanonical(url)
  }, [location.pathname])

  return null
}

function setMeta(attribute: string, key: string, value: string) {
  if (!value) return
  let element = document.querySelector(`meta[${attribute}="${key}"]`) as HTMLMetaElement | null
  if (!element) {
    element = document.createElement('meta')
    element.setAttribute(attribute, key)
    document.head.appendChild(element)
  }
  element.setAttribute('content', value)
}

function setCanonical(url: string) {
  let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null
  if (!link) {
    link = document.createElement('link')
    link.setAttribute('rel', 'canonical')
    document.head.appendChild(link)
  }
  link.setAttribute('href', url)
}
